
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Checkbox
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set, uniqBy } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import { SelectA } from '../../components/form';
import {ResourceAssignment} from './assign';
import {Allotment} from './allotment';
import { ShiftManagement } from './shift';
import {MyTeams} from './myTeams';
// import {GroupTemplates} from './groupTemplate';
const {uniq} = require('lodash');

const API_HOST = CONFIG.modules['accounts'].host



const items = {
    'Manage Shift': {
        name: 'Manage Shift',
        view: ()=> <ShiftManagement/>
    },
    // 'Group Template': {
    //     name: 'Group Template',
    //     view: ()=> <GroupTemplates/>
    // },
    'View Team': {
        name: 'View Team',
        view: ()=> <MyTeams/>
    },
    // 'Assignment': {
    //     name: 'Assignment',
    //     view: ()=> <ResourceAssignment/>
    // },
    // 'Telecaller Allotments': {
    //     name: 'Telecaller Allotments',
    //     view: ()=> (<Allotment/>)
    // },

}



export const ResourceManagement = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, TaskTypes, Campaigns } = useSelector((state) => (state.user || {}))
    const [active, setActive] = useState('Manage Shift');
 
    return (
        <>
            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
           
           {
                items[active]&& items[active].view &&
                items[active].view()
            }
        </>
    )
}